<!-- gzanuttini: Componente que muestra los datos de los recursos -->
<template>
  <div
    id="articulo"
    class="card"
    v-on:keyup.esc="cerrarImagen"
    :key="reload"
    tabindex="-1"
    style="margin-left:3%"
  >
    <div class="headerbtn">
      <button class="btn btn-info btn-sm" style="width:60px" @click="$router.go(-1)">
        <i class="fas fa-arrow-circle-left"></i>
      </button>
      <button class="btn btn-success" style="width:60px" @click="guardar">
        <i class="fas fa-save"></i>
      </button>
    </div>
    <div class="loading" v-if="loading">
      <div class="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="card-body">
      <div class="info card-title" v-if="id">
        <span>{{$i18n.t("previewArticulos.cod")}}: {{articulo.codigo}}</span>
        <br />
        <span>{{$i18n.t("previewArticulos.ean")}}: {{articulo.ean}}</span>
        <br />
        <span>{{$i18n.t("previewArticulos.desc")}}: {{articulo.calcDesc}}</span>
        <br />
      </div>
      <div class="info card-title" v-if="_id">
        <span>_id: {{articulo._id}}</span>
        <br />
        <span>{{$i18n.t("contenedor.name")}}: {{articulo.nombre}}</span>
        <br />
        <span>{{$i18n.t("contenedor.note")}}: {{articulo.nota}}</span>
        <br />
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link pointer"
            @click="activatedPestania(1)"
            v-bind:class="{ active: isActiveRec == 1}"
          >Recursos</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link pointer"
            @click="activatedPestania(2)"
            v-bind:class="{active: isActiveRec == 2}"
          >Links</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link pointer"
            @click="activatedPestania(3)"
            v-bind:class="{active: isActiveRec == 3}"
          >Datos de artículos</a>
        </li>
      </ul>

      <!-- //////////////////////////////////////////IsActiveRec 3////////////////////////////////////////////////////// -->


      <div class="recursos" v-if="isActiveRec == 3">
        <b-container v-if="listadatosarticulos.length > 0">

          <div class="mt-5">
            <b-row >
              <b-col cols="4" md="1" sm="4" xs="4">
                <b-form-group :label="$i18n.t(`datosarticulos.Id`)">
                  <b-form-input size="sm" disabled id="input-id" :placeholder="(listadatosarticulos[0].id).toString()"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col  cols="4" md="3" sm="4" xs="4">
                <b-form-group :label="$i18n.t(`datosarticulos.Codigo`)">
                  <b-form-input size="sm" disabled id="input-cod" :placeholder="(listadatosarticulos[0].codigo)"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4" md="3" sm="4" xs="4">
                <b-form-group :label="$i18n.t(`datosarticulos.CodigoExterno`)">
                  <b-form-input size="sm" disabled id="input-cod-externo" :placeholder="(listadatosarticulos[0].codigo_externo)"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12" cols="12" md="5">
                <b-form-group :label="$i18n.t(`datosarticulos.Descripcion`)">
                  <b-form-input size="sm" disabled id="input-desc" :placeholder="(listadatosarticulos[0].descripcion)"></b-form-input>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label="$i18n.t(`datosarticulos.DescripcionCliente`)">
                <b-form-input size="sm" disabled id="input-desc" :placeholder="(listadatosarticulos[0].desc_cliente)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$i18n.t(`datosarticulos.Marca`)">
                <template v-if="listadatosarticulos[0].marca != null">
                  <b-form-input size="sm" disabled id="input-marca" :placeholder="(listadatosarticulos[0].marca.nombre)"></b-form-input>
                </template>
                <template v-else>
                  <b-form-input size="sm" disabled id="input-marca"></b-form-input>
                </template>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col >
              <b-form-group :label="$i18n.t(`datosarticulos.Modelo`)">
                <b-form-input size="sm" disabled id="input-mod" :placeholder="(listadatosarticulos[0].modelo)"></b-form-input>
              </b-form-group>
              </b-col>
              <b-col >
                <b-form-group :label="$i18n.t(`datosarticulos.Medida`)">
                  <b-form-input size="sm" disabled id="input-med" :placeholder="(listadatosarticulos[0].medida)"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group :label="$i18n.t(`datosarticulos.Alias`)">
                  <b-form-input size="sm" disabled id="input-alias" :placeholder="(listadatosarticulos[0].alias)"></b-form-input>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col sm="6" md="5">
              <b-form-group :label="$i18n.t(`datosarticulos.Familia`)">
                <template v-if="listadatosarticulos[0].familia != null">
                  <b-form-input size="sm" disabled id="input-flia" :placeholder="(listadatosarticulos[0].familia.descripcion)"></b-form-input>
                </template>
                <template v-else>
                  <b-form-input size="sm" disabled id="input-flia"></b-form-input>
                </template>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="2">
              <b-form-group :label="$i18n.t(`datosarticulos.Categoria`)">
                <template v-if="listadatosarticulos[0].categoria != null">
                  <b-form-input size="sm" disabled id="input-cat" :placeholder="(listadatosarticulos[0].categoria.nombre)"></b-form-input>
                </template>
                <template v-else>
                  <b-form-input size="sm" disabled id="input-cat"></b-form-input>
                </template>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="2" style="align-self: center;">
              <b-form-checkbox
                disabled
                v-model="listadatosarticulos[0].publica_web"
                value="true"
                unchecked-value="false"
              >{{$i18n.t("datosarticulos.PublicacionWeb")}}</b-form-checkbox>
            </b-col>
            <b-col cols="12" sm="6" md="3" style="align-self: center;">
              <b-form-checkbox
                disabled
                v-model="listadatosarticulos[0].publica_com_elec"
                value="S"
                unchecked-value="N"
              >{{$i18n.t("datosarticulos.PublicacionComercioElectronico")}}</b-form-checkbox>
            </b-col>
          </b-row>

          </div>
        </b-container>

        <b-container v-if="listadatosarticulos.length == 0">
          <br>
          <div class="card-text">SIN DATOS DE ARTICULOS</div>
        </b-container>

      </div>

      <!-- gzanuttini: Recursos del mismo, si no se encuntran se muestra el no data -->
      <!-- //////////////////////////////////////////IsActiveRec 1////////////////////////////////////////////////////// -->
      <div class="recursos" v-if="isActiveRec == 1">
        <table class="table table-responsive-sm">
          <tr>
            <th></th>
            <th>{{$i18n.t("previewArticulos.fileName")}}</th>
            <th>{{$i18n.t("previewArticulos.uploadDate")}}</th>
            <th>{{$i18n.t('previewArticulos.labels')}}</th>
            <th>{{$i18n.t('previewArticulos.size')}}</th>
            <th>{{$i18n.t('previewArticulos.orden')}}</th>
          </tr>
          <tr v-for="(recurso, index) in recursos" :key="index">
            <td scope="row">
              <i
                class="fas fa-file-video previewImagen"
                style="font-size:2.5em"
                v-if="recurso.content_type && recurso.content_type.includes('video')"
                @click="mostrarImagen(recurso._id,recurso.content_type,recurso.filename)"
              ></i>
              <img
                v-if="recurso.content_type && recurso.content_type.includes('image')"
                :src="url+'/resources/'+recurso._id"
                class="previewImagen"
                @click="mostrarImagen(recurso._id,recurso.content_type,recurso.filename)"
              />
              <img
                v-if="recurso.filename.toLowerCase().includes('.pdf')"
                src="../img/pdf.png"
                class="previewImagen"
                @click="mostrarImagen(recurso._id,recurso.content_type,recurso.filename)"
                alt
              />
              <img
                v-if="recurso.content_type && recurso.filename.toLowerCase().includes('.xls')||recurso.filename.toLowerCase().includes('.xlsx')||recurso.filename.toLowerCase().includes('.xlt')"
                src="../img/xls.png"
                class="previewImagen"
                @click="mostrarImagen(recurso._id,recurso.content_type,recurso.filename)"
                alt
              />
              <audio
                v-if="recurso.content_type && recurso.content_type.includes('audio')"
                controls="controls"
              >
                <source :src="url+'/resources/'+recurso._id" />
              </audio>
              <img v-if="noSoportado(recurso)" src="../img/noSoporte.png" class="previewImagen" />
            </td>
            <td>{{recurso.filename}}</td>
            <td>{{moment(recurso.uploadDate).format('DD/MM/YYYY HH:MM')}}</td>
            <td>
              <span
                class="badge badge-primary"
                style="font-size:13px;margin-left:5px"
                v-for="(label,index) in recurso.labels.map(x=>x.nombre)"
                :key="index"
              >{{label}}</span>
            </td>
            <td>{{calcTamanio(recurso.length)}}</td>
            <td>
              <input
                type="number"
                v-model="recurso.orden"
                class="form-control"
                style="text-align:right; width:100%;"
                min="0"
                max="1000"
              />
            </td>
            <td>
              <button
                class="btn btn-success"
                @click="recursoEdit=recurso"
                :title="$i18n.t('articulo.button.edit')"
              >
                <i class="fas fa-edit"></i>
              </button>
            </td>
            <!-- REALLY EDIT -->
            <!-- <td>
              <button
                @click="recursoEdit2=recurso"
                class="btn btn-success card-link"
                :title="$i18n.t('articulo.button.edit')"
              >
                <i class="fas fa-angle-double-right"></i>
              </button>
            </td>-->
            <!-- FIN REALLY EDIT -->
            <td>
              <button
                v-on:click="desvincularRecurso(recurso._id)"
                class="btn btn-danger card-link"
                :title="$i18n.t('articulo.button.unlink')"
              >
                <i class="fas fa-unlink"></i>
              </button>
            </td>
            <td>
              <button
                v-on:click="descargarRecurso(recurso._id,recurso.filename)"
                class="btn btn-info card-link"
                :title="$i18n.t('articulo.button.download')"
              >
                <i class="fas fa-file-download"></i>
              </button>
            </td>
            <td>
              <button
                v-on:click="eliminarRecurso(recurso)"
                class="btn btn-danger card-link"
                :title="$i18n.t('articulo.button.remove')"
              >
                <i class="fas fa-times"></i>
              </button>
            </td>
          </tr>
        </table>
      </div>

      <!-- //////////////////////////////////////////IsActiveRec 2////////////////////////////////////////////////////// -->

      <div
        v-if="(JSON.stringify(recursos) == '{}' || recursos.length == 0) && isActiveRec == 2"
        class="card"
        style="border:0px !important"
      >
        <div class="card-body">
          <div class="card-text">{{$i18n.t('articulo.empty')}}</div>
        </div>
      </div>

      <div class="w3-display-container contenedorPreview" v-if="imagen.id">
        <button
          class="w3-display-topright btn btn-danger"
          style="margin-top:15px;"
          v-on:click="cerrarImagen"
          v-on:keyup.esc="cerrarImagen"
          tabindex="-1"
        >
          <i class="fa fa-times"></i>
        </button>
        <img
          v-if="imagen.type.includes('image')"
          :src="imagen.id"
          alt
          style="margin-top:5%;"
          class="img-fluid"
        />
        <video
          preload="auto"
          :src="imagen.id"
          v-if="imagen.type.includes('video')"
          autoplay
          style="margin-top:5%;"
          class="img-fluid"
          controls
        ></video>
      </div>
      
      <!-- /////////////////////////////////////// VISUALIZACION VIDEO COMO TABLA /////////////////////////////////////// -->
      
      <div class="links" v-if="isActiveLin">
        
        <div v-if="links != undefined && links.length > 0">
          
          <table class="table table-responsive-sm">
            
            <tr>
              <th></th>
              <th>{{$i18n.t('previewArticulos.titulo')}}</th>
              <th>{{$i18n.t('previewArticulos.tipo')}}</th>
              <th>{{$i18n.t('previewArticulos.labels')}}</th>
              <th>{{$i18n.t('previewArticulos.orden')}}</th>
            </tr>
            
            <tr v-for="(link,index) in links" :key="index">
              
              <td>

                <img
                  :src="`https://img.youtube.com/vi/${obtenerV(link.name)}/0.jpg`"
                  v-if="link.name.includes('youtube') || link.name.includes('youtu.be')"
                  @click="urliframe=link.name;showIframe=true"
                  style="height: 80px; width: 120px;"
                  alt
                /> 
                <img
                  src="https://en.facebookbrand.com/wp-content/uploads/2019/04/f_logo_RGB-Hex-Blue_512.png"
                  v-if="link.name.includes('facebook')"
                  style="height: 169.25px; width: 225px;"
                  alt
                />
                  
              </td>

              <td>
                {{link.desc}}
              </td>

              <td>
                {{link.type}}
              </td>

              <td>
                <span
                  class="badge badge-primary"
                  style="font-size:13px;margin-left:5px"
                  v-for="(tags,index) in link.labels.map(x=>x.nombre)" :key="index"
                >{{tags}}</span>
              </td>
              

              <td>
                
                <div v-if="link.orden.message">
                  <h6 class="card-text" style="color:red;">{{link.orden.message}}</h6>
                </div>
                
                <div v-if="!link.orden.message">

                  <input
                    type="number"
                    v-model="link.orden"
                    class="form-control"
                    style="text-align:right; width:100%;"
                    min="0"
                    max="1000"
                  />

                </div>

                
                
              </td>

              <td>
                <button class="btn btn-success" @click="editarLink(link)">
                  <i class="fas fa-edit"></i>
                </button>
              </td>

              <td>
                <button class="btn btn-danger" @click="eliminarLink(link._id)">
                  <i class="fas fa-times"></i>
                </button>
              </td>

              <td></td>
              <td></td>
            
            
            </tr>

          </table>
        
        </div>
      </div>
    
    </div>

    <!-- /////////////////////////////////////// MODAL /////////////////////////////////////// -->
    <modal-edit :type="(isActiveLin)?'link':'file'" :file="recursoEdit" v-if="recursoEdit"></modal-edit>
    <modal-edit2 :type="(isActiveLin)?'link':'file'" :file="recursoEdit2" v-if="recursoEdit2"></modal-edit2>
    <show-iframe :url="urliframe" v-if="showIframe"></show-iframe>
  </div>
</template>
<script>
/*eslint-disable no-console*/
// import $ from "jquery";
// import slider from "../components/slider";
// import DxDataGrid from "devextreme-vue/data-grid";
// import ws from "../config.json";
import notify from "devextreme/ui/notify";
var getTitleYB = require("get-youtube-title");
import modalEdit from "../components/modalEdit";
import showIframe from "../components/showIframe";


export default {
  name: "articulo",
  props: ["id", "_id"],
  components: {
    // DxDataGrid,
    // slider,
    modalEdit,
    showIframe
  },
  data() {
    return {

      ///
      articulo: {},
      loading: false,
      recursos: {},
      listadatosarticulos: [],
      reload: 0,
      urliframe: undefined,
      showIframe: false,
      moment: require("moment"),
      links: [],
      nameEdit: "",
      isActiveRec: 1,
      editLink: false,
      isActiveLin: false,
      idbuckets: 0,
      url: this.$store.getters.ws.api_recursos,
      recursoEdit: undefined,
      recursoEdit2: undefined,
      request: {
        crossDomain: true,
        headers: {
          EmpID: sessionStorage.getItem("empId"),
          Authorization:
            "Basic " +
            btoa(
              sessionStorage.getItem("usuario") +
                ":" +
                sessionStorage.getItem("clave")
            )
        }
      },
      imagen: {
        id: undefined,
        type: undefined
      }
    };
  },
  methods: {

    activatedPestania(valor){

      if(valor == 1){
        this.isActiveLin = false;
        this.isActiveRec = 1
      }
      if(valor == 2){
        this.isActiveLin = true;
        this.isActiveRec = 2
      }
      if(valor == 3){

        this.isActiveLin = false;
        this.isActiveRec = 3;
        // this.obtenerDatosArticulo();
      }

    },

    async obtenerDatosArticulo(){

      await this.axios({
        method: "get",
        url: this.$store.getters.ws.api_paljet + "/articulos?art_id=" + this.id,
        headers: this.request.headers,
        crossDomain: this.request.crossDomain
      }).then(p => {
        this.listadatosarticulos = p.data.content;
      }).catch(() => {
        notify("No se pudo cargar los datos del articulo", "danger", 5000);
      });

    },

    async obtenerArticulo() {

      await this.axios({
        method: "get",
        url: this.$store.getters.ws.api_paljet + "/articulos/" + this.id,
        headers: this.request.headers,
        crossDomain: this.request.crossDomain
      })
        .then(p => {
          this.articulo = p.data;
          this.idbuckets = p.data.bucket_id;
        })
        .catch((e) => {
          console.log("error al obtenerArticulo");
          console.log(e);
          notify("No se pudo cargar el articulo", "danger", 5000);
        });
    },
    async obtenerBuckets() {
      if (typeof this.idbuckets != "undefined" || this.idbuckets != null) {
        await this.axios
          .get(
            this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets
          )
          .then(r => {
            this.articulo = r.data;
            this.links = this.articulo.links;
            delete this.articulo.links;
          })
          .catch(() => {
            notify("No se pudo cargar los recursos", "danger", 5000);
          });
      }
    },
    async obtenerRecursos() {
      /* aca info links */
      if (typeof this.idbuckets != "undefined" || this.idbuckets != null) {

        await this.axios
          .get(this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets + "/resources")
          .then(r => {
            this.recursos = r.data.content;
            this.links = r.data.links ? r.data.links : [];

            if (this.links && this.links.length > 0) {
              
              for (var items of this.links) {
                
                if (items.metadata == null || items.metadata == 'null' || items.metadata == undefined || items.metadata == 'undefined') {
                  items.labels = []
                } else {
                  items.labels = items.metadata.labels;
                }
                
                if (items.orden == null || items.orden == 'null' || items.orden == undefined || items.orden == 'undefined') {
                  items.orden = {
                    message: "SIN_ORDEN"
                  };
                }
              
              }
            
            }

            this.recursos.forEach(e => {
              if (!e.orden) {
                e.orden = 0;
              }
            });
            this.recursos.sort((a, b) => {
              return a.orden - b.orden;
            });
            this.links.sort((a, b) => {
              return a.orden - b.orden;
            });         
          
          })
          .catch(() => {
            notify("No se pudo cargar los recursos", "danger", 5000);
          });
      }
    },
    obtenerLinks() {
      this.axios
        .get(this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets + "/obtenerLinks")
        .then(async (links) => {
          this.links = links.data;

          if (this.links && this.links.length > 0) {
            for (var items of this.links) {
              if (items.metadata == null || items.metadata == 'null' || items.metadata == undefined || items.metadata == 'undefined') {
                items.labels = []
              } else {
                items.labels = items.metadata.labels;
              }
              if (items.orden == null || items.orden == 'null' || items.orden == undefined || items.orden == 'undefined') {
                items.orden = {
                  message: "SIN_ORDEN"
                };
              }
            }
          }

          this.links.sort((a, b) => {
            return a.orden - b.orden;
          });

          await this.obtenerInfoTituloVideo();
        
        })
        .catch(() => {
          notify("No se pudo cargar los links", "danger", 5000);
        });
    },
    editarLink(link) {
      let aedit = {};
      aedit = { ...link, bucket_id: this.idbuckets };
      this.recursoEdit = aedit;
    },
    mostrarImagen(id, cont, filename) {
      if (cont.includes("image") || cont.includes("video")) {
        this.imagen.id =
          this.$store.getters.ws.api_recursos + "/resources/" + id;
        this.imagen.type = cont;
      } else if (cont.includes("pdf")) {
        window.open(
          this.$store.getters.ws.api_recursos + "/resources/" + id,
          "_blank"
        );
      } else {
        this.axios
          .get(this.$store.getters.ws.api_recursos + "/resources/" + id, {
            responseType: "blob"
          })
          .then(response => {
            let link = document.createElement("a");
            let url = window.URL.createObjectURL(new Blob([response.data]));
            link.href = url;
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          });
      }
    },
    descargarRecurso(id, filename) {
      this.axios
        .get(this.$store.getters.ws.api_recursos + "/resources/" + id, {
          responseType: "blob"
        })
        .then(response => {
          let link = document.createElement("a");
          let url = window.URL.createObjectURL(new Blob([response.data]));
          link.href = url;
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        });
    },
    eliminarLink(_id) {
      var desvincular = confirm(
        this.$i18n.t("previewArticulos.pregDesvincular")
      );
      if (desvincular == true) {
        this.axios.delete(
            this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets + "/desvincular/" + _id
          )
          .then(async () => {
            notify(this.$i18n.t("previewArticulos.confEliminarLink"), "info", 5000);
            await this.obtenerRecursos();
            await this.obtenerInfoTituloVideo();
          });
      }
    },
    desvincularRecurso(idRecurso) {
      var desvincular = confirm(
        this.$i18n.t("previewArticulos.pregDesvincular")
      );
      if (desvincular == true) {
        this.axios
          .delete(this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets + "/link/" + idRecurso)
          .then(() => {
            notify(this.$i18n.t("previewArticulos.confDesvincular"), "info", 5000);
            this.recursos = this.recursos.filter(p => { return p._id != idRecurso; });
          });
      }
    },
    eliminarRecurso(recurso) {
      var desvincular = confirm(this.$i18n.t("previewArticulos.pregEliminar"));
      if (desvincular == true) {
        this.axios.delete(this.$store.getters.ws.api_recursos + "/resources/" + recurso._id, {
          params: {
            bucket_id: recurso.bucket._id
          }
        }).then(() => {
          notify(this.$i18n.t("previewArticulos.confEliminar"), "info", 5000);
          this.recursos = this.recursos.filter(p => { return p._id != recurso._id; });
        });
      }
    },
    noSoportado(recurso) {
      if (
        recurso.filename &&
        recurso.content_type != null &&
        recurso.content_type
      )
        return !(
          recurso.filename.toLowerCase().includes(".xls") ||
          recurso.filename.toLowerCase().includes(".xlsx") ||
          recurso.filename.toLowerCase().includes(".xlt") ||
          recurso.filename.toLowerCase().includes(".pdf") ||
          recurso.content_type.includes("video") ||
          recurso.content_type.includes("image") ||
          recurso.content_type.includes("audio")
        );
      else return recurso.content_type == null;
    },
    cerrarImagen() {
      this.imagen = {
        id: undefined,
        type: undefined
      };
      this.recursoEdit = undefined;
    },
    guardar() {
      //ACA!!
      this.axios
      .put(this.$store.getters.ws.api_recursos + "/buckets/" + this.idbuckets + "/resources", {
          resources: this.recursos.map(p => {
            return {
              _id: p._id,
              orden: p.orden
            };
          }),
          links: this.links.map(p => {
            return {
              name: p.name,
              type: p.type,
              metadata: p.metadata,
              orden: p.orden,
              _id: p._id
            };
          })
        }
      )
      .then(async() => {
        notify("Se grabaron los cambios correctamente", "success", 3000);
        await this.obtenerRecursos();
        await this.obtenerInfoTituloVideo();
        this.links.sort((a, b) => {
          return a.orden - b.orden;
        });
        this.recursos.sort((a, b) => {
          return a.orden - b.orden;
        });
      }).catch(e => {
        console.log("ERROR AL GUARDAR EL ORDEN");
        console.log(e);
        notify("Error al guardar el orden", "error", 3000);
      })
      ;
    },
    calcTamanio(size) {
      if (size > 999999) {
        return (size / 1000000).toFixed(2) + "MB";
      } else {
        return (size / 1000).toFixed(2) + "KB";
      }
    },
    obtenerV(link) {
      if (link.indexOf("&") == -1 && link.indexOf("=") == -1) {
        let result = link.slice(2);
        return result.slice(result.indexOf("/") + 1);
      } else if (link.indexOf("&") == -1) {
        return link.slice(link.indexOf("=") + 1);
      } else {
        return link.slice(link.indexOf("=") + 1, link.indexOf("&"));
      }
    },
    async obtenerTitulo(link) {
      try {
        let apikey=this.$store.getters.apiKeyYT;
        let title = await new Promise((res, rej) => {
          getTitleYB(link, apikey, (err, title) => {
            if (err) {
              rej(err)
            }
            if (title) {
              res(title);
            }
          });
        });
        return title;
      } catch (e) {
        console.log("error al obtener el titulo del video -----");
        console.log(e);
        notify("ERROR AL OBTENER EL TITULO DEL VIDEO", "warning", 2000);
        return "SIN_TITULO";
      }
    },
    async obtenerInfoTituloVideo() {
      console.log("obtenerInfoTituloVideo ------");
      this.links = await Promise.all(
        this.links.map(async p => {
          if (p.type == "youtube") {
            return {
              ...p,
              desc: await this.obtenerTitulo(this.obtenerV(p.name))
            };
          } else {
            return p;
          }
        })
      );
    }
  },
  created: async function() {
    
    if (!this.$store.getters.ws.api_paljet || !this.$store.getters.ws.api_recursos) {
      let ws = sessionStorage.getItem("ws");
      this.$store.commit("setWs",JSON.parse(ws));
      this.url = this.$store.getters.ws.api_recursos;
    }

    if (!this.$store.getters.apiKeyYT) {
      let apiKeyYT = sessionStorage.getItem("apiKeyYT");
      this.$store.commit("setApiKeyYT", apiKeyYT);
    }

    this.loading = true;
    if (this.id) {
      await this.obtenerArticulo();
      await this.obtenerDatosArticulo();
    } else if (this._id) {
      this.idbuckets = this._id;
      await this.obtenerBuckets();
    }
    await this.obtenerRecursos();
    await this.obtenerInfoTituloVideo();
    this.loading = false;
  },
};
</script>
<style>
.tabla{
  background: #36304a;
  color: white;
  font-weight: 700;
  font-size: large;
  width: 50%;
}
#columnsitemstr td{

	font-family: Arial, Helvetica, sans-serif; text-align: center;

}

#columnsitemstr th{

	text-align: center; font-size: 18px; background: #36304a; color: white; font-weight: bold; font-family: Arial, Helvetica, sans-serif;

}

#articulo a {
  color: black !important;
}
.previewImagen {
  height: 64px;
  max-width: 100px;
  cursor: pointer;
}
.contenedorPreview {
  background: rgba(0, 0, 0, 0.78);
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.container-grid {
  display: grid;
  grid-template-columns: 19rem 19rem 19rem 19rem;
  width: 100%;
  justify-content: center;
}
.img-fluid {
  max-width: 660px !important;
}
.box {
  display: flex;
  margin: 15px 30px 15px 30px;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.pointer {
  cursor: pointer;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  z-index: 3;
  left: 6px;
  width: 13px;
  background: rgb(0, 0, 0);
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 45px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
@media (max-width: 950px) {
  .container-grid {
    grid-template-columns: 19rem 19rem 19rem;
  }
  .box {
    margin: 10px 15px 10px 15px !important;
  }
}
@media (max-width: 650px) {
  .container-grid {
    grid-template-columns: 19rem 19rem;
  }
  .box {
    margin: 7.5px 5px 7.5px 5px !important;
  }
}
@media (max-width: 500px) {
  .container-grid {
    grid-template-columns: 19rem;
  }
  .box {
    margin: 5px !important;
  }
}
.headerbtn {
  display: flex;
  justify-content: space-between;
}
</style>
